import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/divida/listar/form_edit'
import Head from '../../../../components/head'


function EditarDividaScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Dívida Ativa" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarDividaScreen;